export const appLayoutID = 'app-layout';
